import * as ajax from './ajax';
import infoConstants from '../constants/infoConstants';

/*
*  Attempts to get the server version info from the /version endpoint
*/
const initServerInfo = () => async dispatch => {
  const versionURL = `${ajax.getBaseURL()}version`;
  const response = await ajax.getFromProvidedURL(versionURL);
  return dispatch({
    type: infoConstants.SERVER_INFO_SUCCESS,
    data: response.data
  });
};
const infoActions = {
  initServerInfo
};
export default infoActions;